import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

const axios = createAxiosInstance(env.libraryApiUrl, {
  camelizeKeys: true,
});

export async function getCampaignDeliverables({
  brandId,
  campaignId,
  channel,
  postType,
  tags,
  status,
  handle,
  sort,
  shouldPaginate,
}) {
  return axios.get(`/brands/${brandId}/campaigns/${campaignId}/deliverables`, {
    params: {
      channel: channel?.join(','),
      postType: postType?.join(','),
      tags: tags?.join(','),
      status: status?.join(','),
      handle,
      sort,
      shouldPaginate,
    },
  });
}

export async function updateCampaignDeliverables({
  brandId,
  campaignId,
  creatorIds,
  deliverableTiktokVideos,
  deliverableInstagramFeed,
  deliverableInstagramReels,
  deliverableInstagramStories,
  deliverableYoutubeVideos,
  deliverableYoutubeShorts,
  deliverableGifted,
  status,
}) {
  return axios.post(`/brands/${brandId}/campaigns/${campaignId}/deliverables`, {
    creatorIds,
    deliverableTiktokVideos,
    deliverableInstagramFeed,
    deliverableInstagramReels,
    deliverableInstagramStories,
    deliverableYoutubeVideos,
    deliverableYoutubeShorts,
    deliverableGifted,
    status,
  });
}

export async function removeCampaignDeliverables({ brandId, campaignId, creatorIds }) {
  return axios.delete(`/brands/${brandId}/campaigns/${campaignId}/creators`, {
    params: {
      creatorIds: creatorIds.join(','),
    },
  });
}

export async function includeCreatorMediaInCampaign({ brandId, campaignId, mediaIds }) {
  return axios.post(`/brands/${brandId}/campaigns/${campaignId}/creators/include_media`, {
    mediaIds,
  });
}

export async function excludeCreatorMediaFromCampaign({ brandId, campaignId, mediaIds }) {
  return axios.post(`/brands/${brandId}/campaigns/${campaignId}/creators/exclude_media`, {
    mediaIds,
  });
}

export async function createOrderLink({ brandId, campaignId, sparkAdsAuthorized }) {
  return axios.post(`/brands/${brandId}/campaigns/${campaignId}/ttcm_order`, {
    sparkAdsAuthorized,
  });
}
